let Resource = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.delete();
    },

    delete: function () {
        $('.delete-resource').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/resources/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const resourceForm = $('#resourceForm');

        if (resourceForm.length) {
            let submitBtn = Ladda.create(resourceForm.find('[type=submit]')[0]);

            resourceForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/resources/' + response.data.id + '/edit');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });

            this.toggleFields();
            $(document).on('change', '#resourceIsUrl', () => {
                this.toggleFields();
            });
        }

        $('#resources').on('draw.dt', function () {
            _this.delete();
        });
    },

    toggleFields() {
        console.log($('#resourceIsUrl').val());
        if ($('#resourceIsUrl').val() === '1') {
            console.log('Type 1');
            $('#resourceFile').closest('.form-group').hide();
            $('#resourceUrl').closest('.form-group').show();
        } else {
            console.log('Type 0');
            $('#resourceFile').closest('.form-group').show();
            $('#resourceUrl').closest('.form-group').hide();
        }
    },
};

$().ready(function () {
    window.Resource = Resource;
    window.Resource.init();
});
